/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LayoutCenterRewardRecord.vue?vue&type=template&id=0000ef76&scoped=true"
import script from "./LayoutCenterRewardRecord.vue?vue&type=script&lang=js"
export * from "./LayoutCenterRewardRecord.vue?vue&type=script&lang=js"
import style0 from "./LayoutCenterRewardRecord.vue?vue&type=style&index=0&id=0000ef76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0000ef76",
  null
  
)

export default component.exports